import { render, staticRenderFns } from "./DailyUsage.vue?vue&type=template&id=389890e8&scoped=true&"
import script from "./DailyUsage.vue?vue&type=script&lang=js&"
export * from "./DailyUsage.vue?vue&type=script&lang=js&"
import style0 from "./DailyUsage.vue?vue&type=style&index=0&id=389890e8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389890e8",
  null
  
)

export default component.exports